import React, { type Dispatch, type SetStateAction } from 'react';

import {
  AtomicFooterType,
  AtomicHeaderType,
  AtomicItemListType,
  type IScreensComponent,
} from '../../../api';
import {
  HeadlineSmallOneLine,
  HeadlineSmallOneLineWithText,
  HeadlineSmallOneLineWithTextCompact,
  HeadlineXsmallOneLine,
  HeadlineOnlyText,
  HeadlineSmallTwoLineWithTimer,
  HeadlineReloadOneLine,
} from '../Header';
import {
  Divider,
  GoodsCarousel,
  ProfileInfo,
  ThreeColGoodsList,
  TwoColGoodsList,
  TwoColCardList,
  ThreeColCardList,
  TwoLineMessage,
  Proxy,
  FilterList,
  Empty,
  NotificationGuide,
  CompanyInfo,
  SearchBar,
  NeonSignBoard,
  Summary,
  HorizontalChipList,
  FourColIconList,
  FiveColIconList,
  ScrollableIconList,
  MarketBadgeList,
  StoreList,
  TwoImageMarketCarousel,
  ThreeImageMarketCarousel,
  RollingBannerList,
  BannerCarousel,
  DescriptionCardCarousel,
  PhotoReviewCarousel,
  VerticalBannerList,
} from '../ItemList';
import { FooterMore } from '../Footer';

export const HeaderComponent = {
  [AtomicHeaderType.HeadlineSmallOneLine]: HeadlineSmallOneLine,
  [AtomicHeaderType.HeadlineXsmallOneLine]: HeadlineXsmallOneLine,
  [AtomicHeaderType.HeadlineSmallOneLineWithText]: HeadlineSmallOneLineWithText,
  [AtomicHeaderType.HeadlineSmallOneLineWithTextCompact]:
    HeadlineSmallOneLineWithTextCompact,
  [AtomicHeaderType.HeadlineOnlyText]: HeadlineOnlyText,
  [AtomicHeaderType.HeadlineSmallTwoLineWithTimer]:
    HeadlineSmallTwoLineWithTimer,
  [AtomicHeaderType.HeadlineReloadOneLine]: HeadlineReloadOneLine,
};

export const ItemListComponent = {
  [AtomicItemListType.PROFILE_INFO]: ProfileInfo,
  [AtomicItemListType.Divider]: Divider,
  [AtomicItemListType.GoodsCarousel]: GoodsCarousel,
  [AtomicItemListType.FilterList]: FilterList,
  [AtomicItemListType.TwoColGoodsList]: TwoColGoodsList,
  [AtomicItemListType.TwoColCardList]: TwoColCardList,
  [AtomicItemListType.ThreeColGoodsList]: ThreeColGoodsList,
  [AtomicItemListType.ThreeColCardList]: ThreeColCardList,
  [AtomicItemListType.TwoLineMessage]: TwoLineMessage,
  [AtomicItemListType.Proxy]: Proxy,
  [AtomicItemListType.Empty]: Empty,
  [AtomicItemListType.NotificationGuide]: NotificationGuide,
  [AtomicItemListType.CompanyInfo]: CompanyInfo,
  [AtomicItemListType.SearchBar]: SearchBar,
  [AtomicItemListType.NeonSignBoard]: NeonSignBoard,
  [AtomicItemListType.Summary]: Summary,
  // Phase 2: Medium-Easy (단순 리스트형)
  [AtomicItemListType.HorizontalChipList]: HorizontalChipList,
  [AtomicItemListType.FourColIconList]: FourColIconList,
  [AtomicItemListType.FiveColIconList]: FiveColIconList,
  [AtomicItemListType.ScrollableIconList]: ScrollableIconList,
  [AtomicItemListType.MarketBadgeList]: MarketBadgeList,
  [AtomicItemListType.StoreList]: StoreList,
  [AtomicItemListType.TwoImageMarketCarousel]: TwoImageMarketCarousel,
  [AtomicItemListType.ThreeImageMarketCarousel]: ThreeImageMarketCarousel,
  [AtomicItemListType.RollingBannerList]: RollingBannerList,
  [AtomicItemListType.BannerCarousel]: BannerCarousel,
  [AtomicItemListType.DescriptionCardCarousel]: DescriptionCardCarousel,
  [AtomicItemListType.PhotoReviewCarousel]: PhotoReviewCarousel,
  [AtomicItemListType.VerticalBannerList]: VerticalBannerList,
};

export const FooterComponent = {
  [AtomicFooterType.More]: FooterMore,
};

export const createAtomicComponent = (params: {
  component: IScreensComponent;
  index: number;
  likeMap: Record<string, boolean>;
  setLikeMap: Dispatch<SetStateAction<Record<string, boolean>>>;
  scrollToFilterList?: VoidFunction;
  onReload?: () => void;
  screen?: string;
}) => {
  const { component, likeMap, setLikeMap, scrollToFilterList, onReload } =
    params;
  const Header = component.type.header
    ? HeaderComponent[component.type.header]
    : null;

  const Footer = component.type.footer
    ? FooterComponent[component.type.footer]
    : null;

  const ItemList = component.type.itemList
    ? ItemListComponent[component.type.itemList]
    : null;

  return (
    <>
      {Header && (
        <Header  screen={params.screen} header={component.entity.header} onReload={onReload} />
      )}
      {ItemList && component.entity.itemList && (
        <ItemList
          screen={params.screen}
          entity={component.entity.itemList}
          body={component.entity.body}
          logging={component.logging}
          scrollToFilterList={
            scrollToFilterList ? scrollToFilterList : () => {}
          }
          likeMap={likeMap}
          setLikeMap={setLikeMap}
        />
      )}
      {Footer && (
        <Footer screen={params.screen} footer={component.entity.footer} />
      )}
    </>
  );
};
